import { DraftSpecialTextConfiguration, SpecialFontTask } from '@/types';
import { convertSizePxToSizeMm } from '@/model/configuration/convertSize';
import { updateSizeAndOffset } from './updateSizeAndOffset';

export const setSpecialFontTask = (
  configuration: DraftSpecialTextConfiguration,
  task: SpecialFontTask
) => {
  configuration.task = task;
  updateSizeAndOffset(configuration, convertSizePxToSizeMm(task.size, configuration.printType));
};
